window.app = window.app || {};
app.ui = app.ui || {};

app.ui.form = {
    init: () => {
        app.ui.form.bindings();
    },
    bindings: () => {
        document.querySelectorAll('select').forEach(select => {
            select.addEventListener('change', (event) => {
                select.closest('div.form.select').classList.remove('is-placeholder');
            });
        });
    }
};